import {lazy} from "react";

export const ReportDevicePlanningExecutionLazy = lazy(()=>import('./ReportDevicePlanningExecution'))